module.exports = __webpack_public_path__ + "img/con3.5305aefb.jpg";